import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
  POST_SALES_CORPORATE,
  POST_SALES_APARTMENT,
  CAT_BY_PRODUCT,
  TAG,
  CONTRACT_APARTMENT,
  CONTRACT_CORPORATE,
  CONTRACT_SUPPLY,
  CLIENT_FOR_FINANCE,
  CAT_BY_BRAND
} from "./type";

export const postCorporate = (leadId,commId="") => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    // `${Config.postSales.corporateContract}${leadId}/${commId}`
    `${Config.postSales.corporateContract}?lead_id=${leadId}&comm_id=${commId}`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    if (payload?.status === true || payload?.status === 0) {
      const data = payload?.data ?? outer?.data;
      dispatch({ type: POST_SALES_CORPORATE, payload: data });
      return true;
    }
  }
};

export const postApartment = (leadId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postSales.appartmentContract}${leadId}`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    const data = payload?.data ?? outer?.data;
    dispatch({ type: POST_SALES_APARTMENT, payload: data });
    return data;
  }
};

export const getAllClients = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postSales.getAllClientsForFinanceBusiness}`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    if (payload?.status === true || payload?.status === 0) {
      const data = payload?.data ?? outer?.data;
      dispatch({ type: CLIENT_FOR_FINANCE, payload: data });
      return true;
    }
  }
};

export const getMateriaById = (id,brand_id=null) => async (dispatch) => {
  const req = {"cat_id":id,"brand_id":brand_id};
  const res = await callWebService(
    callTypes.post,
    req,
    `${Config.postSales.getMaterial}${id}`
  );
  if (res?.data?.status === true) {
    const { data } = res;
    dispatch({ type: CAT_BY_PRODUCT, payload: data.response.data });
    return data.response.data;
  }
};

export const getBrandById = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    "",
    `${Config.postSales.getBrand}${id}`
  );
  if (res?.data?.status === true) {
    const { data } = res;
    dispatch({ type: CAT_BY_BRAND, payload: data.response.data });
    return data.response.data;
  }
};


export const getTagById = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    "",
    `${Config.postSales.getTag}`
  );
  if (res?.data?.status === true) {
    const { data } = res;
    dispatch({ type: TAG, payload: data.response.data });
    return true;
  }
};

export const contractApartment = (requestData) => async (dispatch) => {
  dispatch({ type: CONTRACT_APARTMENT, payload: [] });
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postSales.apartmentContractData}?lead_id=${requestData.manageId}&comm_id=${requestData.id}&is_edit_contract=1`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    if (payload?.status === true || payload?.status === 0) {
      const data = payload?.data ?? outer?.data;
      dispatch({ type: CONTRACT_APARTMENT, payload: data });
      return true;
    }
  }
};

export const contractCorporate = (requestData) => async (dispatch) => {
  dispatch({ type: CONTRACT_CORPORATE, payload: [] });
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postSales.corpContractData}?lead_id=${requestData.manageId}&comm_id=${requestData.id}&is_edit_contract=1`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    if (payload?.status === true || payload?.status === 0) {
      const data = payload?.data ?? outer?.data;
      dispatch({ type: CONTRACT_CORPORATE, payload: data });
      return true;
    }
  }
};

export const contractSupply = (requestData) => async (dispatch) => {
  dispatch({ type: CONTRACT_SUPPLY, payload: [] });
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postSales.supplyContractData}?lead_id=${requestData.manageId}&comm_id=${requestData.id}&is_edit_contract=1`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    if (payload?.status === true || payload?.status === 0) {
      const data = payload?.data ?? outer?.data;
      dispatch({ type: CONTRACT_SUPPLY, payload: data });
      return true;
    }
  }
};